import React, {Component} from 'react';
import {connect} from 'react-redux'

import {locale} from '../locale/AppLocale'
import Loader from "../Components/Loader";
import {Field, reduxForm, change as changeForm, formValueSelector, getFormValues} from 'redux-form'
import ProductInput from '../Components/ProductInput'
import * as updateSellActions from '../actions/updateSellActions'
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import { Tooltip as ReactTooltip } from 'react-tooltip'
import axios from 'axios';
import Breadcrumb from '../Components/Breadcrumb';

import {push as routerPush} from 'react-router-redux'
import isEmpty from 'validator/lib/isEmpty';
import isInt from 'validator/lib/isInt';
import isFloat from 'validator/lib/isFloat';
import trim from 'validator/lib/trim';
import ShooqModal from '../Components/ShooqModal';
import {Link} from 'react-router-dom'
import Config from '../Helpers/Config';
import * as authActions from '../actions/authActions'

import {NotificationManager} from '../Helpers/NotificationManager';;

import PiecesModal from '../Components/PiecesModal';
import {FixFormValues} from "../Helpers/FixFormValues";
import {GetEntityAttribute} from "../Helpers/Entity";

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;

const selector = formValueSelector('sellForm');


const validate = (values) => {

    const errors = {};

    if (!values.title_ar || isEmpty(trim(values.title_ar))) {
        errors.title_ar = locale.get('required');
    }
    if (!values.quantity || isEmpty(values.quantity.toString())) {
        errors.quantity = locale.get('required');
    } else if (!isInt(values.quantity.toString())) {
        errors.quantity = locale.get('numeric_only');
    }
    if (!values.price || isEmpty(trim(values.price.toString()))) {
        errors.price = locale.get('required');
    } else if (!isFloat(values.price.toString())) {
        errors.price = locale.get('numeric_only');
    }
    if (values.old_price && !isEmpty(trim(values.old_price.toString())) && !isFloat(values.old_price.toString())) {
        errors.old_price = locale.get('numeric_only');
    }

    let handling_time = values.handling_time;
    if (typeof handling_time === 'object' && typeof handling_time.value !== 'undefined'){
        handling_time = handling_time.value;
    }

    if (!handling_time || !isInt(handling_time.toString())) {
        errors.handling_time = locale.get('required', {
            field: locale.get('handling_time')
        });
    }

    if (!values.pcondition) {
        errors.pcondition = locale.get('required');
    }
    // if (!values.shipping_delivery_option) {
    //     errors.shipping_delivery_option = locale.get('required');
    // }
    if (!values.pickup_from || !isInt(values.pickup_from.toString())) {
        errors.pickup_from = locale.get('required');
    }

    if (values.notes && !isEmpty(trim(values.notes.toString()))) {
        let _notes = trim(values.notes.toString());
        _notes = _notes.replace(/(<([^>]+)>)/ig, "")
            .replace(/&nbsp;/gi, ' ');
        if (_notes.length > 500) {
            errors.notes = locale.get('string_max_length_exceeded', {size: 500});
        }
    }

    return errors;
};

const checkBoxInput = ({input, id, type}) => {
    return (
        <input
            {...input}
            id={id}
            type={type}/>
    );
};

const inputMessage = ({meta}) => {
    return (
        <div className={` input-c  ` + (meta.error ? 'has-error ' : '')}>
            {meta.touched
            && ((meta.error &&
            <div className="has-error"><span className="help-block is-error">{meta.error}</span></div> )
            || (meta.warning && <span>{meta.warning}</span>))}
        </div>
    )
}

class UpdateSellProduct extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
            requiresPiecesUpdate: false
        };
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.updateAddress = this.updateAddress.bind(this);
        this.onSubmitPieces = this.onSubmitPieces.bind(this);
        this.onRefusePieces = this.onRefusePieces.bind(this);
        this.hasSelfShipping = this.hasSelfShipping.bind(this);
        this.canShippingToRegion = this.canShippingToRegion.bind(this);
        this.getSelectedAddress = this.getSelectedAddress.bind(this);
    }

    componentDidMount() {
        this.props.fetchProductInfo(this.props.match.params.id);
    }

    onSubmit(values) {
        if (values.price < 100) {
            this.setState({
                requiresPiecesUpdate: true
            })
        } else {
            this.props.toggleFormActionStatus(true);
            this.sendUpdateRequest(values);
        }
    }

    onSubmitPieces(price) {
        let values = this.props.selectorAll();
        values.pieces = price[0].pieces;
        values.price = price[0].price;
        this.props.toggleFormActionStatus(true);
        this.sendUpdateRequest(values);
    }

    onRefusePieces() {
        let values = this.props.selectorAll();
        this.props.toggleFormActionStatus(true);
        this.sendUpdateRequest(values);
    }

    sendUpdateRequest(values) {
        this.props.toggleFormActionStatus(true);

        let data  ={
            title_ar: values.title_ar,
            price: values.price,
            old_price: values.old_price,
            quantity: values.quantity,
            sku: values.sku,
            notes: values.notes,
            handling_time: values.handling_time,
            pcondition: values.pcondition,
            shipping_delivery_option: values.shipping_delivery_option,
            free_shipping: values.free_shipping ? 1 : 0,
            free_shipping_48: values.free_shipping_48 ? 1 : 0,
            free_shipping_jerusalem: values.free_shipping_jerusalem ? 1 : 0,
            free_shipping_gaza: values.free_shipping_gaza ? 1 : 0,
            shipping_by_seller: values.shipping_by_seller ? 1 : 0,
            pickup_from: values.pickup_from,
            pieces: values.pieces
        };

        data = FixFormValues(data);

        axios.post(`${Config.api() }product/update-sell/${this.props.match.params.id}`, data, {
            withCredentials: Config.withCredentials()
        }).then((response) => {
            this.props.toggleFormActionStatus(false);
            if (response.data.status === true) {
                NotificationManager.success(locale.get('your_product_updated_successfully'), values.title_ar);
                this.props.navigateTo(`/${this.props.match.params.businessSlug}/manage/`);
            } else {
                NotificationManager.error(locale.get('an_error_occurred_while_submitting_form'));
            }
        }).catch((error) => {
            if (error.response.status === 401) {
                this.props.requiresReLogin();
            } else {
                if(error.response.data && error.response.data.message){
                    NotificationManager.error(error.response.data.message);
                }else{

                    NotificationManager.error(locale.get('an_error_occurred_while_submitting_form'));
                }
            }
            this.props.toggleFormActionStatus(false);
        });
    }


    getProductImages() {
        let images = [];
        this.props.updateSell.images.forEach((img, index) => {
            images.push({original: img.full, thumbnail: img.thumb});
        });
        return images;
    }


    showModal() {
        this.setState({openModal: true});
    }

    closeModal(...proxy) {
        this.setState({openModal: false});
    }

    renderModalContent() {
        if (!this.state.openModal) {
            return;
        }
        let userProduct = this.props.updateSell;

        return (
            <div>
                <div className="product-details">
                    <div className="product-details--gallery">
                        <ImageGallery
                            thumbnailPosition={'bottom'}
                            items={this.getProductImages()}
                            slideInterval={2000}
                            showPlayButton={false}
                        />
                    </div>
                    <div className="product-details--attributes">
                        <ul className="product-details--props">
                            {userProduct.attributes[0] && userProduct.attributes[0].attributes.map((property, index) => {
                                if (index < 10) {
                                    return (
                                        <li key={index}>
                                            <span className="product-details--prop-name">{GetEntityAttribute(property,'title')}: </span>
                                            <span className="product-details--prop-value">{GetEntityAttribute(property,'value_text')}</span>
                                        </li>
                                    );
                                }
                                return '';
                            })}
                        </ul>
                    </div>
                </div>
                <div className="clearfix"></div>
                <div className="mt-30">
                    {userProduct.attributes[0] && userProduct.attributes.map((propertyGroup, index) => {

                        let className = 'table ';
                        if (index > 0) {
                            className += ' mt-30 ';
                        }

                        return (
                            propertyGroup.attributes && propertyGroup.attributes.length > 0 && <div key={index}>
                                <table className={className} width="100%">
                                    <thead>
                                    <tr>
                                        <td colSpan="2" className="table--head">{propertyGroup.name}</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        propertyGroup.attributes.map((property, index) => {
                                            return (
                                                <tr key={index}>
                                                    <th className="bg-white" width="50%">{GetEntityAttribute(property,'title')}</th>
                                                    <td className="bg-white" width="50%">{GetEntityAttribute(property,'value_text')}</td>
                                                </tr>
                                            );
                                        })
                                    }
                                    </tbody>
                                </table>
                                <div className="clearfix"></div>
                            </div>
                        );
                    })
                    }

                </div>
                {
                    (userProduct.base_description_ar && userProduct.base_description_ar.length > 0) ? (
                        <div>
                            <table className='table mt-30' width="100%">
                                <thead>
                                <tr>
                                    <td className="table--head">{locale.get('product_details')}</td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="bg-white no-hover"
                                        dangerouslySetInnerHTML={this.createMarkup(userProduct.base_description_ar)}></td>
                                </tr>
                                </tbody>
                            </table>
                            <div className="clearfix"></div>
                        </div>
                    ) : ('')
                }

            </div>
        );
    }

    createMarkup(string) {
        return {__html: string};
    }

    updateAddress(newAddress) {
        this.props.changeForm('pickup_from', newAddress.id);
    }

    getSelectedAddress(){
        const pickupFrom = parseInt(this.props.selector('pickup_from'), 10);
        const addresses = this.props.updateSell.seller.addresses;
        if(!pickupFrom || !addresses){
            return false;
        }
        let index = addresses.findIndex((address) => {
            return address.id === pickupFrom;
        });
        if (!addresses[index]) {
            return false;
        }
        return addresses[index];
    }
    hasSelfShipping() {
        const selectedAddress = this.getSelectedAddress();
        if (!selectedAddress) {
            return false;
        }

        return selectedAddress.can_shipping_products || false;
    }
    canShippingToRegion(regionLocation) {
        const selectedAddress = this.getSelectedAddress();

        if (!selectedAddress || !selectedAddress['can_shipping_to_region']) {
            return false;
        }
        if(!selectedAddress['can_shipping_to_region'][regionLocation]){
            return false;
        }
        return selectedAddress['can_shipping_to_region'][regionLocation];
    }

    render() {

        return (
            <Loader completed={this.props.updateSell.fetched}>
                {this.state.openModal ? (<ShooqModal showModal={this.state.openModal} onRequestClose={this.closeModal}
                                                      modalTitle={

                                                          <div>
                                                          <span
                                                              className={`ml-10 badge badge--` + this.props.updateSell.status }>
                                                      {GetEntityAttribute(this.props.updateSell,'status_text')}
                                                          </span>
                                                              <span>{GetEntityAttribute(this.props.updateSell,'title')}</span>
                                                          </div>
                                                      }
                                                      modalSubTitle={GetEntityAttribute(this.props.updateSell,'category_title')}>

                    {this.renderModalContent()}

                </ShooqModal>) : ('')}


                {
                    this.state.requiresPiecesUpdate &&
                    <PiecesModal
                        price={this.props.selector('price')}
                        onSubmit={this.onSubmitPieces}
                        onClose={() => this.setState({requiresPiecesUpdate: false})}
                        onRefuse={this.onRefusePieces}/>
                }


                <div className="panel-1">
                    <div className="panel-1--head bg-white">
                        <span className={`ml-10 badge badge--` + this.props.updateSell.status }>
                            {GetEntityAttribute(this.props.updateSell,'status_text')}
                        </span>

                        {locale.get('sell_the_product')} <span>{GetEntityAttribute(this.props.updateSell,'title') || ''}</span>

                    </div>
                    <div className="panel-1--breadcrumb">
                        <Breadcrumb items={this.props.updateSell.breadcrumb}
                                    prefix={locale.get('edit_product_breadcrumb_prefix')}/>
                    </div>

                    <div className="panel-1--body is-full">
                        <div className="product-details clearfix">

                            <div className="product-details--gallery">
                                <ImageGallery
                                    thumbnailPosition={'bottom'}
                                    items={this.getProductImages()}
                                    slideInterval={2000}
                                    showPlayButton={false}
                                />
                            </div>
                            <div className="product-details--attributes">
                                <ul className="product-details--props">
                                    {this.props.updateSell.attributes[0] && this.props.updateSell.attributes[0].attributes.map((property, index) => {
                                        if (index < 10) {
                                            return (
                                                <li key={index}>
                                                    <span
                                                        className="product-details--prop-name">{GetEntityAttribute(property,'title')}: </span>
                                                    <span
                                                        className="product-details--prop-value">{GetEntityAttribute(property,'value_text')}</span>
                                                </li>
                                            );
                                        }
                                        return '';
                                    })}
                                    <li>
                                        <Link className="" to="#"
                                              onClick={ this.showModal }>{  locale.get('show_product_details') }</Link>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="panel-1">
                    <form className="form-horizontal" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this)) }>
                        <div className="panel-1--body is-full">
                            <div className="inner-content-width">

                                <div className="tooltip-field" data-scroll-hide={true}
                                     data-event="click focusin focus" data-event-off="focusout" data-tip=''
                                     data-tooltip-id='tooltip_product_title_ar' data-iscapture="false" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="title_ar"
                                        id="product_title_ar"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('product_title_ar')}
                                        placeholder={locale.get('product_title_ar')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_product_title_ar'>{locale.get('product_title_ar')}</ReactTooltip>
                                </div>


                                <div className="tooltip-field" data-scroll-hide={true}
                                     data-event="click focusin focus" data-event-off="focusout" data-tip=''
                                     data-tooltip-id='tooltip_quantity' data-iscapture="false" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="quantity"
                                        id="quantity"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('quantity')}
                                        placeholder={locale.get('quantity')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_quantity'>{locale.get('sell_product_tooltip_quantity')}</ReactTooltip>
                                </div>

                                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                                     data-event="click focusin focus" data-event-off="focusout"
                                     data-tooltip-id='tooltip_price' data-iscapture="false" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="price"
                                        id="price"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('price')}
                                        placeholder={locale.get('price')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_price'>{locale.get('sell_product_tooltip_price')}</ReactTooltip>
                                </div>

                                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                                     data-html="true"
                                     data-event="click focusin focus" data-event-off="focusout"
                                     data-tooltip-id='tooltip_old_price' data-iscapture="false" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="old_price"
                                        id="old_price"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('old_price')}
                                        placeholder={locale.get('old_price')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_old_price'>{locale.get('sell_product_tooltip_old_price')}</ReactTooltip>
                                </div>

                                <div className="tooltip-field" data-tip='' data-scroll-hide={true}
                                     data-event="click focusin focus" data-event-off="focusout"
                                     data-tooltip-id='tooltip_sku' data-iscapture="false" data-place="left"
                                     data-effect="solid" data-multiline="true">
                                    <Field
                                        type="text"
                                        name="sku"
                                        id="sku"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('sku')}
                                        placeholder={locale.get('sku')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_sku'>{locale.get('sell_product_tooltip_sku')}</ReactTooltip>
                                </div>

                                <div className="tooltip-field"
                                     data-tooltip-id='tooltip_notes'
                                     data-tip=''
                                     data-scroll-hide={true}
                                     data-iscapture={false}
                                     data-place="left"
                                     data-html="true"
                                     data-effect="solid"
                                     data-multiline="true">
                                    <Field
                                        type="textarea"
                                        name="notes"
                                        id="notes"
                                        component={ProductInput}
                                        className="form-control"
                                        label={locale.get('seller_notes')}
                                        placeholder={locale.get('seller_notes')}
                                        field={{}}/>
                                    <ReactTooltip
                                        id='tooltip_notes'>{locale.get('sell_product_tooltip_notes')}</ReactTooltip>
                                </div>

                                <Field
                                    name="pcondition"
                                    id="pcondition"
                                    component={ProductInput}
                                    className="form-control"
                                    ref="hand"
                                    label={locale.get('product_condition')}
                                    placeholder={locale.get('product_condition')}
                                    field={{data_type: "dropdown", options: this.props.updateSell.product_conditions}}
                                />
                                <Field
                                    name="handling_time"
                                    id="handling_time"
                                    component={ProductInput}
                                    className="form-control"
                                    ref="hand"
                                    label={locale.get('handling_time')}
                                    placeholder={locale.get('handling_time')}
                                    field={{data_type: "dropdown", options: this.props.updateSell.handling_times}}/>

                                <div className="addresses-list ">
                                    <div className="label">{locale.get('pickup_from')}</div>
                                    <div className="">
                                        {this.props.updateSell.seller.addresses.map((address, index) => {
                                            return (
                                                <div key={index}
                                                     onClick={() => {
                                                         this.updateAddress(address)
                                                     }}
                                                     className={ parseInt(this.props.pickup_from, 0) === parseInt(address.id, 0) ? `address--item is-active` : `address--item`}
                                                     htmlFor={`pickup_from-` + address.id}>
                                                    <label htmlFor={`pickup_from-` + address.id}>
                                                        <Field
                                                            type="radio"
                                                            name={`pickup_from`}
                                                            id={`pickup_from-` + address.id}
                                                            component={checkBoxInput}
                                                            className="form-control"
                                                            defaultChecked={true}
                                                            value={address.id.toString()}
                                                            field={{}}
                                                        />
                                                        <div className="address--item--name">{address.name}</div>
                                                        <div
                                                            className="address--item--address">{address.address_1}</div>
                                                        <div className="address--item--address">{address.address}</div>
                                                        <div className="address--item--phone">{address.phone}</div>
                                                    </label>
                                                </div>
                                            );
                                        })}
                                        <Field name={`pickup_from`} component={inputMessage}/>
                                    </div>
                                </div>


                                {
                                    this.hasSelfShipping() ? <div >
                                        <Field
                                            type="checkbox"
                                            name="shipping_by_seller"
                                            id="shipping_by_seller"
                                            data-tooltip-id="tooltip_shipping_by_seller"
                                            component={ProductInput}
                                            className="form-control"
                                            label={locale.get('shipper')}
                                            alt_label={locale.get('shipping_by_seller')}
                                            field={{}}/>
                                        <ReactTooltip
                                            id='tooltip_shipping_by_seller'>{locale.get('sell_product_tooltip_shipping_by_seller')}</ReactTooltip>
                                    </div>
                                        : ''
                                }
                                <div className="clearfix"/>

                                {/*<div >*/}
                                {/*    <Field*/}
                                {/*        name="shipping_delivery_option"*/}
                                {/*        id="shipping_delivery_option"*/}
                                {/*        component={ProductInput}*/}
                                {/*        className="form-control"*/}
                                {/*        ref="hand"*/}
                                {/*        label={locale.get('shipping_delivery_option')}*/}
                                {/*        placeholder={locale.get('shipping_delivery_option')}*/}
                                {/*        field={{data_type: "dropdown", options: this.props.updateSell.shipping_delivery_options_list || [] }}/>*/}

                                {/*</div>*/}
                                <div className="clearfix"/>
                                {/*{*/}
                                {/*    this.getSelectedAddress() ? <div className="alert alert-warning mb-30 text-right">{locale.get('free_shipping_notification_message')}</div> : ''*/}
                                {/*}*/}
                                {/*<div className="clearfix"/>*/}

                                {/*<div className="tooltip-field" data-tip='' data-scroll-hide={true}*/}
                                {/*     data-event="click focusin focus" data-event-off="focusout"*/}
                                {/*     data-tooltip-id='tooltip_free_shipping' data-iscapture="false" data-place="left"*/}
                                {/*     data-effect="solid" data-multiline="true">*/}

                                {/*    {*/}
                                {/*        this.canShippingToRegion('westbank') ? <Field*/}
                                {/*            type="checkbox"*/}
                                {/*            name="free_shipping"*/}
                                {/*            id="free_shipping"*/}
                                {/*            component={ProductInput}*/}
                                {/*            className="form-control"*/}
                                {/*            label={locale.get('shipping_to_westbank')}*/}
                                {/*            alt_label={locale.get('free_shipping')}*/}
                                {/*            field={{}}/>*/}
                                {/*            : ''*/}
                                {/*    }*/}
                                {/*    {*/}
                                {/*        this.canShippingToRegion('jerusalem') ? <Field*/}
                                {/*            type="checkbox"*/}
                                {/*            name="free_shipping_jerusalem"*/}
                                {/*            id="free_shipping_jerusalem"*/}
                                {/*            component={ProductInput}*/}
                                {/*            className="form-control"*/}
                                {/*            label={locale.get('shipping_to_jerusalem')}*/}
                                {/*            alt_label={locale.get('free_shipping_jerusalem')}*/}
                                {/*            field={{}}/>*/}
                                {/*            : ''*/}
                                {/*    }*/}
                                {/*    {*/}
                                {/*        this.canShippingToRegion('48_area') ? <Field*/}
                                {/*            type="checkbox"*/}
                                {/*            name="free_shipping_48"*/}
                                {/*            id="free_shipping_48"*/}
                                {/*            component={ProductInput}*/}
                                {/*            className="form-control"*/}
                                {/*            label={locale.get('shipping_to_48_area')}*/}
                                {/*            alt_label={locale.get('free_shipping_48')}*/}
                                {/*            field={{}}/>*/}
                                {/*            : ''*/}
                                {/*    }*/}
                                {/*    {*/}
                                {/*        this.canShippingToRegion('gaza') ? <Field*/}
                                {/*            type="checkbox"*/}
                                {/*            name="free_shipping_gaza"*/}
                                {/*            id="free_shipping_gaza"*/}
                                {/*            component={ProductInput}*/}
                                {/*            className="form-control"*/}
                                {/*            label={locale.get('shipping_to_gaza')}*/}
                                {/*            alt_label={locale.get('free_shipping_gaza')}*/}
                                {/*            field={{}}/>*/}
                                {/*            : ''*/}
                                {/*    }*/}

                                {/*    <ReactTooltip*/}
                                {/*        id='tooltip_free_shipping'>{locale.get('sell_product_tooltip_free_shipping')}</ReactTooltip>*/}
                                {/*</div>*/}

                            </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="panel-1--footer">
                            <button className="btn-1" disabled={this.props.formActions.submittingForm}><Loader
                                completed={this.props.formActions.submittingForm === false}/> {locale.get('btn_update')}
                            </button>
                        </div>
                    </form>
                </div>
            </Loader>

        );
    }

}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth,
        updateSell: state.updateSell,
        initialValues: {...state.updateSell, title_ar: state.updateSell.original_title},
        formActions: state.formActions,
        pickup_from: selector(state, 'pickup_from'),
        selectorAll: () => getFormValues('sellForm')(state),
        selector: (field) => selector(state, field),
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => {
    return {
        changeForm: (field, value) => dispatch(changeForm('sellForm', field, value)),
        fetchProductInfo: (businessId, id) => dispatch(updateSellActions.fetchProduct(businessId, id)),
        redirect: (url) => dispatch(routerPush(url)),
        toggleFormActionStatus: (status) => dispatch({
            type: 'FORM_SUBMITTING_CHANGE_STATUS',
            status: status
        }),
        requiresReLogin: () => dispatch(authActions.requiresRelogin())
    }
};

UpdateSellProduct = reduxForm({
    form: 'sellForm',
    enableReinitialize: true,
    onChange: (values, dispatch, props) => {
        // console.log('values',values,props)
    },
    validate:validate
})(UpdateSellProduct);

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSellProduct);
